import React from 'react';
import { Modal, Button, ListGroup, Badge, Row, Col, Card } from 'react-bootstrap';
import { FaBug } from 'react-icons/fa';

const LogDetailsModal = ({ log, show, onHide, getStatusBadge }) => {
    if (!log) return null;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable>
            <Modal.Header closeButton className="border-0 bg-light">
                <Modal.Title className="d-flex align-items-center">
                    <FaBug className="me-2 text-primary" /> Request Audit Log
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light p-4">
                <div className="log-details">
                    <h6 className="mb-3 text-muted text-uppercase fw-bold letter-spacing-1">General Info</h6>
                    <ListGroup className="mb-4 shadow-sm border-0">
                        <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 py-3">
                            <span>Endpoint:</span>
                            <strong className="text-primary">{log.method} {log.url}</strong>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 py-3 bg-white">
                            <span>Status:</span>
                            {getStatusBadge(log.status)}
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 py-3">
                            <span>Timestamp:</span>
                            <strong>{new Date(log.createdAt).toLocaleString()}</strong>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 py-3 bg-white">
                            <span>Latency (Speed):</span>
                            <Badge bg={log.duration > 1000 ? 'danger' : 'secondary'}>{log.duration}ms</Badge>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex justify-content-between align-items-center border-0 py-3">
                            <span>Source IP:</span>
                            <strong>{log.ipAddress}</strong>
                        </ListGroup.Item>
                    </ListGroup>

                    <h6 className="mb-3 text-muted text-uppercase fw-bold letter-spacing-1">Payload Details</h6>
                    <Row className="g-3">
                        <Col md={12}>
                            <Card className="border-0 shadow-sm mb-3">
                                <Card.Header className="bg-dark text-white py-2 small">Request Body</Card.Header>
                                <Card.Body className="p-0">
                                    <pre className="m-0 p-3 bg-dark text-light small overflow-auto" style={{ maxHeight: '200px', fontSize: '12px' }}>
                                        {JSON.stringify(log.requestBody, null, 2)}
                                    </pre>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className="border-0 shadow-sm mb-3">
                                <Card.Header className="bg-dark text-white py-2 small">Response Body</Card.Header>
                                <Card.Body className="p-0">
                                    <pre className="m-0 p-3 bg-dark text-success small overflow-auto" style={{ maxHeight: '300px', fontSize: '12px' }}>
                                        {JSON.stringify(log.responseBody, null, 2)}
                                    </pre>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {log.errorMessage && (
                        <div className="mt-4">
                            <h6 className="mb-3 text-danger text-uppercase fw-bold letter-spacing-1">Stack Trace</h6>
                            <Card className="border-0 shadow-sm border-start border-danger border-4">
                                <Card.Body>
                                    <p className="text-danger fw-bold mb-2">{log.errorMessage}</p>
                                    {log.stackTrace && (
                                        <pre className="small bg-light p-2 rounded overflow-auto" style={{ maxHeight: '250px', fontSize: '11px' }}>
                                            {log.stackTrace}
                                        </pre>
                                    )}
                                </Card.Body>
                            </Card>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 bg-light">
                <Button variant="secondary" onClick={onHide}>Close Window</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogDetailsModal;
